/* eslint-disable no-undef */
/* eslint-disable prettier/prettier */
import Vue from "vue";
import Router from "vue-router";
import NoFound from "./views/ErrorPage/404.vue";
import ForBidden from "./views/ErrorPage/403.vue";
import NoNotwork from "./views/ErrorPage/500.vue";
import findLast from "lodash/findLast"
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import { check } from "./utils/auth";
import { notification } from "ant-design-vue";

Vue.use(Router);
// let role=this.store.state.roleList;
const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/user",
      hideInMenu: true,
      component: { render: h => h("router-view") },
      children: [
        {
        path: "/user",
        redirect: "/user/login",
        hideChildrenInMenu: true
      }, 
      {
        path: "/user/login",
        name: "login",
        component: () =>
          import(/* webpackChunkName: "user" */ "./views/User/Login")
      }
      ]
    }, {
      path: "/document",
      hideInMenu: true,
      component: { render: h => h("router-view") },
      children: [{
        path: "/setting/document",
        name: "document",
        component: () =>
          import(/* webpackChunkName: "user" */ "./views/Setting/Document")
      }
      ]
    }, {
      path: '/summary',
      hideInMenu: true,
      component: { render: h => h("router-view") },
      children: [{
        path: "/recruitCost/summary",
        name: "summary",
        component: () =>
          import(/* webpackChunkName: "user" */ "./views/RecruitCost/Summary")
      }
      ]
    },
    {
      path: "/",
      // meta: { authority: ["招聘专员", "技术测试"] },
      component: () =>
        import(/* webpackChunkName: "layout" */ "./Layouts/BasicLayout"),
      children: [
        {
          path: "/",
          redirect: "/user/login",
          hideChildrenInMenu: true
        },
        {
          path: "/user/home",
          name: "home",
          meta: { icon: "home", title: "首页" },
          isChildren: false,
          component: () =>
            import(/* webpackChunkName: "user" */ "./views/User/Home")
        },
        {
          path: "/management",
          name: "management",
          meta: { icon: "pie-chart", title: "运营中心", type: ['玄鸟内部'], authority: ["BOSS", "技术", "运营支持", "项目总监", "项目经理","项目驻场","招聘组长","财务","出纳"]  },
          component: { render: h => h("router-view") },
          isChildren: true,
          children: [
            {
              path: "/management",
              redirect: "/management/interview",
              hideChildrenInMenu: true
            },
            // {
            //   path: "/management/statistical",
            //   name: "statistical",
            //   meta: { title: "运营数据", authority: ["招聘专员", "BOSS", "项目负责人", "技术", "运营支持", "片区经理"] },
            //   component: () =>
            //     import(/* webpackChunkName: "account" */ "./views/Management/Statistical")
            // },
            {
              path: "/management/operationDaily",
              name: "operationDaily",
              meta: { title: "运营日报", authority: ["BOSS", "技术", "运营支持", "项目总监", "项目经理","项目驻场","招聘组长","财务","出纳"] },
              component: () =>
                import(/* webpackChunkName: "account" */ "./views/Management/OperationDaily")
            },
            // {
            //   path: "/management/operationProDaily",
            //   name: "operationProDaily",
            //   meta: { title: "运营项目数据", authority: ["招聘专员", "BOSS", "项目负责人", "技术", "运营支持", "片区经理"] },
            //   component: () =>
            //     import(/* webpackChunkName: "account" */ "./views/Management/OperationProDaily")
            // },
            // {
            //   path: "/management/Recruiter",
            //   name: "recruiter",
            //   meta: { title: "线上日报", authority: ["BOSS", "技术", "运营支持", "项目总监", "项目经理","项目驻场","自招","招聘组长","招聘专员"] },
            //   component: () =>
            //     import(/* webpackChunkName: "account" */ "./views/Management/Recruiter")
            // }, 
            {
              path: "/management/proDaily",
              name: "proDaily",
              meta: { title: "项目日报", authority: ["BOSS", "技术", "运营支持", "项目总监", "项目经理","项目驻场","招聘组长","招聘专员","财务","出纳"] },
              component: () =>
                import(/* webpackChunkName: "account" */ "./views/Management/ProDaily")
            }, {
              path: "/management/channelConversionRate",
              name: "channelConversionRate",
              meta: { title: "渠道数据", authority: ["BOSS", "技术", "运营支持","招聘组长","招聘专员","财务","出纳"] },
              component: () =>
                import(/* webpackChunkName: "account" */ "./views/Management/ChannelConversionRate")
            },
            // {
            //   path: "/account/manualReview",
            //   name: "manualReview",
            //   meta: { title: "认证签约",authority:[ "技术"]},
            //   component: () =>
            //     import(/* webpackChunkName: "account" */ "./views/Account/ManualReview")
            // },
            // {
            //   path: "/account/worker",
            //   name: "worker",
            //   meta: { title: "员工列表",authority:[ "技术"] },
            //   component: () =>
            //     import(/* webpackChunkName: "business" */ "./views/Account/Worker")
            // }, 
            {
              path: "/Worker/Index",
              name: "workerIndex",
              meta: { title: "全部员工",authority:[ "BOSS", "技术", "运营支持","招聘组长","财务","出纳" ] },
              component: () =>
                import(/* webpackChunkName: "business" */ "./views/Worker/Index")
            },
            {
              path: "/Worker/MyList",
              name: "WorkerMyList",
              meta: { title: "关联项目员工",authority:[ "技术","项目总监", "项目经理","项目驻场"] },
              component: () =>
                import(/* webpackChunkName: "business" */ "./views/Worker/MyList")
            },
            {
              path: "/Worker/log",
              name: "workerLog",
              meta: { title: "所有入离职记录",authority:["BOSS", "技术", "运营支持","招聘组长" ,"财务","出纳"] },
              component: () =>
                import(/* webpackChunkName: "business" */ "./views/Worker/Log")
            },
            {
              path: "/Worker/ProLog",
              name: "WorkerProLog",
              meta: { title: "关联项目入离职记录",authority:[ "技术","项目总监", "项目经理","项目驻场"] },
              component: () =>
                import(/* webpackChunkName: "business" */ "./views/Worker/ProLog")
            }, 
            {
              path: "/Worker/MyLog",
              name: "WorkerMyLog",
              meta: { title: "我操作的入离职记录",authority:[ "技术","项目总监", "项目经理","项目驻场"] },
              component: () =>
                import(/* webpackChunkName: "business" */ "./views/Worker/MyLog")
            }, 
            // {
            //   path: "/account/download",
            //   name: "workerDownload",
            //   meta: { title: "员工数据下载",authority:["BOSS", "技术", "运营支持", "项目总监", "项目经理","项目驻场"] },
            //   component: () =>
            //     import(/* webpackChunkName: "business" */ "./views/Account/Download")
            // }, 
            {
              path: "/management/workLog",
              name: "workLog",
              meta: { title: "工作日志", authority: ["BOSS", "技术"] },
              component: () =>
                import(/* webpackChunkName: "account" */ "./views/Management/WorkLog")
            },{
              path: "/errorPage/log",
              name: "errorPageLog",
              meta: { title: "错误日志", authority: ["技术"] },
              component: () =>
                import(/* webpackChunkName: "errorPage" */ "./views/ErrorPage/Log")
            },
          ]
        }, {
          path: "/resource",
          name: "resource",
          meta: { icon: "solution", title: "员工中心", type: ['玄鸟内部'], authority: ["BOSS", "技术", "运营支持", "项目总监", "项目经理","项目驻场","招聘组长","招聘专员"] },
          component: { render: h => h("router-view") },
          isChildren: true,
          children: [

            // {
            //   path: "/management/interview",
            //   name: "interviewLog",
            //   meta: { title: "面试", authority: ["BOSS", "技术", "运营支持", "项目总监", "项目经理","项目驻场"] },
            //   component: () =>
            //     import(/* webpackChunkName: "account" */ "./views/Management/Interview")
            // },
            {

              path: "/management/visitLog",
              name: "visitLog",
              meta: { title: "拜访", authority: ["BOSS", "技术", "运营支持", "项目总监", "项目经理","项目驻场"] },
              component: () =>
                import(/* webpackChunkName: "account" */ "./views/Management/VisitLog")
            },
            //  {
            //   path: "/management/entryLog",
            //   name: "entryLog",
            //   meta: { title: "入职", authority: ["BOSS", "技术", "运营支持", "项目总监", "项目经理","项目驻场","招聘组长"] },
            //   component: () =>
            //     import(/* webpackChunkName: "account" */ "./views/Management/EntryLog")
            // }, {
            //   path: "/management/demissionLog",
            //   name: "demissionLog",
            //   meta: { title: "离职", authority: ["BOSS", "技术", "运营支持", "项目总监", "项目经理","项目驻场","招聘组长"] },
            //   component: () =>
            //     import(/* webpackChunkName: "account" */ "./views/Management/DemissionLog")
            // },
            {
              path: "/management/collection",
              name: "collection",
              meta: { title: "收藏列表", authority: ["BOSS", "技术", "运营支持"] },
              component: () =>
                import(/* webpackChunkName: "account" */ "./views/Management/Collection")
            },
            {
              path: "/management/feedback",
              name: "feedback",
              meta: { title: "问题反馈", authority: ["BOSS", "技术", "运营支持", "项目总监", "项目经理","项目驻场"] },
              component: () =>
                import(/* webpackChunkName: "account" */ "./views/Management/Feedback")
            },
            {
              path: "/resource/resume",
              name: "resume",
              meta: { title: "资源库", authority: ["BOSS", "技术", "运营支持", "项目总监", "项目经理","招聘组长","招聘专员"] },
              component: () =>
                import(/* webpackChunkName: "account" */ "./views/Resource/Resume")
            }, {
              path: "/resource/allInvitation",
              name: "resourceAllInvitation",
              meta: { title: "邀约带面", authority: ["BOSS", "技术", "运营支持", "招聘组长","招聘专员"] },
              component: () =>
                import(/* webpackChunkName: "account" */ "./views/Resource/AllInvitation")
            }, 
            {
              path: "/resource/channel",
              name: "channel",
              meta: { title: "招聘渠道", authority: ["BOSS", "技术", "运营支持", "招聘组长"] },
              component: () =>
                import(/* webpackChunkName: "business" */ "./views/Resource/Channel")
            },
            {
              path: "/resource/post",
              name: "resourcePost",
              meta: { title: "所有招聘岗位", authority: ["BOSS", "技术", "运营支持", "招聘组长"] },
              component: () =>
                import(/* webpackChunkName: "account" */ "./views/Resource/Post")
            },
            {
              path: "/resource/demand",
              name: "demand",
              meta: { title: "所有招聘缺口", authority: ["BOSS", "技术", "运营支持","招聘组长"] },
              component: () =>
                import(/* webpackChunkName: "account" */ "./views/Resource/Demand")
            }, 
            {
              path: "/resource/resourceCostDaily",
              name: "resourceCostDaily",
              meta: { title: "成本日报", authority: ["BOSS", "技术", "运营支持", "招聘组长","招聘专员"] },
              component: () =>
                import(/* webpackChunkName: "tasks" */ "./views/Resource/CostDaily")
            },]
        },
        {
          path: "/tripartite",
          name: "tripartite",
          meta: { icon: "dot-chart", title: "运营中心", type: ["三方公司"], authority: ["BOSS", "技术", "运营支持", "项目总监", "项目经理","招聘组长","招聘专员","财务","出纳"]  },
          component: { render: h => h("router-view") },
          isChildren: true,
          children: [{
            path: "/tripartite",
            redirect: "/tripartite/Recruiter",
            hideChildrenInMenu: true
          }, {
            path: "/tripartite/ResumeThree",
            name: "tripartiteResumeThree",
            meta: { title: "简历库" },
            component: () =>
              import(/* webpackChunkName: "tasks" */ "./views/Tripartite/ResumeThree")
          }, {
            path: "/tripartite/operationDaily",
            name: "tripartiteOperationDaily",
            meta: { title: "运营日报", authority: ["BOSS", "技术", "运营支持", "项目总监", "项目经理","招聘组长","招聘专员","财务","出纳"] },
            component: () =>
              import(/* webpackChunkName: "tasks" */ "./views/Tripartite/OperationDaily")
          },{
            path:"/tripartite/aLlDemand",
            name: "tripartiteALlDemand",
            meta: { title: "所有招聘缺口", authority: ["BOSS", "技术", "运营支持", "项目总监", "项目经理","招聘组长","招聘专员","财务","出纳"] },
            component: () =>
              import(/* webpackChunkName: "tasks" */ "./views/Tripartite/ALlDemand")
          }, {
            path: "/tripartite/allInvitation",
            name: "tripartiteAllInvitation",
            meta: { title: "邀约带面", authority: ["BOSS", "技术", "运营支持", "项目总监", "项目经理","招聘组长","招聘专员","财务","出纳"] },
            component: () =>
              import(/* webpackChunkName: "tasks" */ "./views/Tripartite/AllInvitation")
          }, {
            path: "/tripartite/worker",
            name: "tripartiteWorker",
            meta: { title: "员工列表", authority: ["BOSS", "技术", "运营支持", "项目总监", "项目经理","招聘组长","招聘专员","财务","出纳"] },
            component: () =>
              import(/* webpackChunkName: "tasks" */ "./views/Tripartite/Worker")
          },
          {
            path: "/tripartite/log",
            name: "tripartiteLog",
            meta: { title: "入离职记录", authority: ["BOSS", "技术", "运营支持", "项目总监", "项目经理","招聘组长","招聘专员","财务","出纳"] },
            component: () =>
              import(/* webpackChunkName: "tasks" */ "./views/Tripartite/Log")
          },
          //  {
          //   path: "/tripartite/entryLog",
          //   name: "tripartiteEntryLog",
          //   meta: { title: "入职记录", authority: ["BOSS", "技术", "运营支持", "项目总监", "项目经理","招聘组长","招聘专员"] },
          //   component: () =>
          //     import(/* webpackChunkName: "tasks" */ "./views/Tripartite/EntryLog")
          // }, {
          //   path: "/tripartite/demissionLog",
          //   name: "tripartiteDemissionLog",
          //   meta: { title: "离职记录", authority: ["BOSS", "技术", "运营支持", "项目总监", "项目经理","招聘组长","招聘专员"] },
          //   component: () =>
          //     import(/* webpackChunkName: "tasks" */ "./views/Tripartite/DemissionLog")
          // }
        ]
        },

        {
          path: "/CapitalBoard",
          name: "CapitalBoard",
          meta: { icon: "pay-circle", title: "费用看板", type: ['玄鸟内部'], authority: ["项目总监", "项目经理","项目驻场"] },
          component: { render: h => h("router-view") },
          isChildren: true,
          children: [
            {
              path: "/CapitalBoard",
              redirect: "/CapitalBoard/ServiceCharge",
              hideChildrenInMenu: true
            },{
              path:"/CapitalBoard/MyExpense",
              name: "CapitalBoardMyExpense",
              meta: { title: "我的报销" },
              component: () =>
                import(/* webpackChunkName: "money" */ "./views/CapitalBoard/MyExpense")
            },
            {
              path: '/CapitalBoard/ServiceCharge',
              name: "CapitalBoardServiceCharge",
              meta: { title: "招聘费" },
              component: () =>
                import(/* webpackChunkName: "money" */ "./views/CapitalBoard/ServiceCharge")
            },    {
              path: "/CapitalBoard/advance",
              name: "CapitalBoardAdvance",
              meta: { title: "预支" },
              component: () =>
                import(/* webpackChunkName: "money" */ "./views/CapitalBoard/Advance")
            },
             {
              path: "/CapitalBoard/calculation",
              name: "CapitalBoardCalculation",
              meta: { title: "离职/提前结算" },
              component: () =>
                import(/* webpackChunkName: "money" */ "./views/CapitalBoard/Calculation")
            },
            {
              path:"/CapitalBoard/laborer",
              name: "CapitalBoardLaborer",
              meta: { title: "临时工" },
              component: () =>
                import(/* webpackChunkName: "money" */ "./views/CapitalBoard/Laborer")
            },{
              path:"/CapitalBoard/Compensation",
              name: "CapitalBoardCompensation",
              meta: { title: "买赔结算" },
              component: () =>
                import(/* webpackChunkName: "money" */ "./views/CapitalBoard/Compensation")
            },
              {
              path:"/CapitalBoard/allowanceLog",
              name: "CapitalBoardAllowanceLog",
              meta: { title: "补扣记录" },
              component: () =>
                import(/* webpackChunkName: "business" */ "./views/CapitalBoard/AllowanceLog")
            },
          ]
        },
        {
          path: "/task",
          name: "task",
          meta: { icon: "smile", title: "招聘中心", authority: ["BOSS", "技术", "运营支持", "项目总监", "项目经理","招聘组长","招聘专员"]  },
          component: { render: h => h("router-view") },
          isChildren: true,
          children: [
            {
              path: "/task",
              redirect: "/task/tasks",
              hideChildrenInMenu: true
            },
            {
              path: "/task/taskDemand",
              name: "taskDemand",
              meta: { title: "招聘缺口", type: ['玄鸟内部'] },
              component: () =>
                import(/* webpackChunkName: "tasks" */ "./views/Task/Demand")
            }, {
              path: "/task/taskTripartiteRecruit",
              name: "taskTripartiteRecruit",
              meta: { title: "招聘缺口",type: ['三方公司'] },
              component: () =>
                import(/* webpackChunkName: "tasks" */ "./views/Task/TripartiteRecruit")
            },
            {
              path:"/task/resume/myCreate",
              name: "taskResumeMyCreate",
              meta: { title: "我的资源", type: ['三方公司', '玄鸟内部'] },
              component: () =>
                import(/* webpackChunkName: "tasks" */ "./views/Task/ResumeMyCreate")
            },{
              path:"/task/resumeMyCollection",
              name: "taskResumeMyCollection",
              meta: { title: "我的收藏",  type: ['三方公司', '玄鸟内部'] },
              component: () =>
                import(/* webpackChunkName: "tasks" */ "./views/Task/ResumeMyCollection")
            },
            {
              path: "/task/resume/invitationList",
              name: "taskInvitationList",
              meta: { title: "我的邀约",  type: ['三方公司', '玄鸟内部'] },
              component: () =>
                import(/* webpackChunkName: "tasks" */ "./views/Task/InvitationList")
            }, 
            {
              path: "/task/resume/interviewTask",
              name: "tasksInterviewTask",
              meta: { title: "带面任务", type: ['三方公司', '玄鸟内部'] },
              component: () =>
                import(/* webpackChunkName: "tasks" */ "./views/Task/InterviewTask")
            },{
              path: "/task/taskCostDaily",
              name: "taskCostDaily",
              meta: { title: "成本日报",  type: ['玄鸟内部'] },
              component: () =>
                import(/* webpackChunkName: "tasks" */ "./views/Task/CostDaily")
            },
          ]
        },
        {
          path: "/recruitCost",
          name: "recruitCost",
          meta: { icon: "calculator", title: "招聘费数据", type: ['玄鸟内部'], authority: ["技术"], },
          component: { render: h => h("router-view") },
          isChildren: true,
          children: [
            {
              path: "/recruitCost",
              redirect: "/recruitCost/index",
              hideChildrenInMenu: true
            }, {
              path: '/recruitCost/index',
              name: "recruitCostIndex",
              meta: { title: "核算配置" },
              component: () =>
                import(/* webpackChunkName: "recruitCost" */ "./views/RecruitCost/Index")
            },
            // {
            //   path: '/recruitCost/HumanCost',
            //   name: "recruitCostHumanCost",
            //   meta: { title: "人力成本" },
            //   component: () =>
            //     import(/* webpackChunkName: "recruitCost" */ "./views/RecruitCost/HumanCost")
            // },
            {
              path:"/recruitCost/Fee",
              name: "recruitCostFee",
              meta: { title: "费用相关" },
              component: () =>
                import(/* webpackChunkName: "recruitCost" */ "./views/RecruitCost/Fee")
            }
          ]
        },
        {
          path: "/business",
          name: "business",
          meta: { icon: "appstore", title: "项目中心", type: ['玄鸟内部'] , authority: ["BOSS", "技术", "运营支持", "项目总监", "项目经理","招聘组长","招聘专员","财务","出纳"]},
          component: { render: h => h("router-view") },
          isChildren: true,
          children: [
            {
              path: "/business",
              redirect: "/business/project",
              hideChildrenInMenu: true
            }, {
              path: '/business/project',
              name: "project",
              meta: { title: "项目", authority: ["BOSS", "技术", "运营支持","财务","出纳"] },
              component: () =>
                import(/* webpackChunkName: "business" */ "./views/Business/Project")
            },
            {
              path: '/business/framework',
              name: "framework",
              meta: { title: "项目架构", authority: ["BOSS", "技术", "运营支持","财务","出纳"] },
              component: () =>
                import(/* webpackChunkName: "business" */ "./views/Business/Framework")
            },
            {
              path: "/resource/workerRole",
              name: "workerRole",
              meta: { title: "入职岗位", authority: ["BOSS", "技术", "运营支持","财务","出纳"] },
              component: () =>
                import(/* webpackChunkName: "business" */ "./views/Business/WorkerRole")
            },
            {
              path: '/customer/index',
              name: "customer",
              meta: { title: "客户公司", authority: ["BOSS", "技术", "运营支持","财务","出纳"] },
              component: () =>
                import(/* webpackChunkName: "business" */ "./views/Customer/Index")
            },
            {
              path: '/customer/account',
              name: "customerAccount",
              meta: { title: "合作商", authority: ["BOSS", "技术", "运营支持"] },
              component: () =>
                import(/* webpackChunkName: "business" */ "./views/Customer/Account")
            },
            {
              path: "/management/customerLog",
              name: "customerLog",
              meta: { title: "合作商拜访", authority: ["BOSS", "技术", "运营支持", "项目总监", "项目经理","财务","出纳"] },
              component: () =>
                import(/* webpackChunkName: "account" */ "./views/Management/CustomerLog")
            },
            {
              path: "/business/clean",
              name: "cleanClearing",
              meta: { title: "公寓服务", authority: ["BOSS", "技术", "运营支持", "公寓服务管理人员","财务","出纳" ] },
              component: () =>
                import(/* webpackChunkName: "business" */ "./views/Business/Clean")
            },
            {
              path: "/business/retail",
              name: "retail",
              meta: { title: "即时配送", authority: ["BOSS", "运营支持", "技术", '即时配送管理人员',"财务","出纳"] },
              component: () =>
                import(/* webpackChunkName: "business" */ "./views/Business/Retail")
            },
            {
              path: "/business/manpower",
              name: "manpower",
              meta: { title: "人力外包", authority: ["BOSS", "技术", "运营支持", "人力外包管理人员","财务","出纳"] },
              component: () =>
                import(/* webpackChunkName: "business" */ "./views/Business/Manpower")
            },
            {
              path: "/business/logistics",
              name: "logistics",
              meta: { title: "城配物流", authority: ["BOSS", "技术", "城配物流管理人员", "运营支持","财务","出纳"] },
              component: () =>
                import(/* webpackChunkName: "business" */ "./views/Business/Logistics")
            },
            {
              path: "/business/equipment",
              name: "equipment",
              meta: { title: "设备运维", authority: ["BOSS", "技术", "设备运维管理人员", "运营支持","财务","出纳"] },
              component: () =>
                import(/* webpackChunkName: "business" */ "./views/Business/Equipment")
            },
            {
              path: "/business/mapProject",
              name: "mapProject",
              meta: { title: "地图项目", authority: ["BOSS", "技术", "运营支持", "项目总监", "项目经理","招聘组长"] },
              component: () =>
                import(/* webpackChunkName: "business" */ "./views/Business/MapProject")
            },
            {
              path: "/business/mapList",
              name: "mapList",
              meta: { title: "地图标记", authority: ["BOSS", "技术", "运营支持", "项目总监", "项目经理","招聘组长"] },
              component: () =>
                import(/* webpackChunkName: "business" */ "./views/Business/MapList")
            },
            {
              path: '/business/map',
              name: "map",
              meta: { title: "地图展示", authority: ["BOSS", "技术", "运营支持", "项目总监", "项目经理","招聘组长","招聘专员"] },
              component: () =>
                import(/* webpackChunkName: "business" */ "./views/Business/Map")
            },
          ]
        },
        {
          path: "/money",
          name: "money",
          meta: { icon: "pay-circle", title: "资金管理", type: ['玄鸟内部'], authority: ["BOSS", "技术", "出纳", "财务","运营支持"] },
          component: { render: h => h("router-view") },
          isChildren: true,
          children: [
            {
              path: "/money",
              redirect: "/money/cost",
              hideChildrenInMenu: true
            },
            //  {
            //   path: "/money/ChannelSettle",
            //   name: "moneyChannelSettle",
            //   meta: { title: "渠道结算" },
            //   component: () =>
            //     import(/* webpackChunkName: "money" */ "./views/Money/ChannelSettle")
            // },
            {
              path: "/money/payable",
              name: "moneyPayable",
              meta: { title: "项目收支" },
              component: () =>
                import(/* webpackChunkName: "money" */ "./views/Money/Payable")
            },
            {
              path: '/money/cost',
              name: "moneyCost",
              meta: { title: "费用明细" },
              component: () =>
                import(/* webpackChunkName: "money" */ "./views/Money/Cost")
            },
            {
              path: "/money/expense",
              name: "moneyExpense",
              meta: { title: "报销" },
              component: () =>
                import(/* webpackChunkName: "money" */ "./views/Money/Expense")
            },
            {
              path: "/money/advance",
              name: "moneyAdvance",
              meta: { title: "预支" },
              component: () =>
                import(/* webpackChunkName: "money" */ "./views/Money/Advance")
            },
             {
              path: "/money/calculation",
              name: "moneyCalculation",
              meta: { title: "离职/提前结算" },
              component: () =>
                import(/* webpackChunkName: "money" */ "./views/Money/Calculation")
            },
            {
              path:"/money/laborer",
              name: "moneyLaborer",
              meta: { title: "临时工" },
              component: () =>
                import(/* webpackChunkName: "money" */ "./views/Money/Laborer")
            },{
              path:"/money/Compensation",
              name: "moneyCompensation",
              meta: { title: "买赔结算" },
              component: () =>
                import(/* webpackChunkName: "money" */ "./views/Money/Compensation")
            },
            {
              path: "/money/typeStatistics",
              name: "moneyTypeStatistics",
              meta: { title: "类型统计" },
              component: () =>
                import(/* webpackChunkName: "money" */ "./views/Money/TypeStatistics")
            },
            {
              path: "/money/Statement",
              name: "moneyStatement",
              meta: { title: "出入帐记录" },
              component: () =>
                import(/* webpackChunkName: "money" */ "./views/Money/Statement")
            },
            {
              path: "/money/analyze",
              name: "moneyAnalyze",
              meta: { title: "账款分析表" },
              component: () =>
                import(/* webpackChunkName: "money" */ "./views/Money/Analyze")
            }, {
              path: "/money/project",
              name: "moneyProject",
              meta: { title: "项目设置" },
              component: () =>
                import(/* webpackChunkName: "money" */ "./views/Money/Project")
            },
            {
              path: "/money/CostType",
              name: "moneyCostType",
              meta: { title: "费用类型" },
              component: () =>
                import(/* webpackChunkName: "money" */ "./views/Money/CostType")
            },
            {
              path: "/money/platform",
              name: "moneyPlatform",
              meta: { title: "外包平台" },
              component: () =>
                import(/* webpackChunkName: "money" */ "./views/Money/Platform")
            }
            ,{
              path:"/money/STPayment",
              name: "moneySTPayment",
              meta: { title: "杉泰发薪" },
              component: () =>
                import(/* webpackChunkName: "money" */ "./views/Money/STPayment")
            } ,{
              path:"/money/HYPayment",
              name: "moneyHYPayment",
              meta: { title: "华垚发薪" },
              component: () =>
                import(/* webpackChunkName: "money" */ "./views/Money/HYPayment")
            },{
              path:"/money/CPICPayment",
              name: "moneyCPICPayment",
              meta: { title: "太平洋保险发薪" },
              component: () =>
                import(/* webpackChunkName: "money" */ "./views/Money/CPICPayment")
            }
          ]
        },
        {
          path: "/insurance",
          name: "insurance",
          meta: { icon: "property-safety", title: "保险管理", type: ["玄鸟内部"], authority: ["BOSS", "技术", "运营支持", "项目总监", "项目经理","招聘组长"] },
          component: { render: h => h("router-view") },
          isChildren: true,
          children: [
            {
              path: "/insurance",
              redirect: "/insurance/cost",
              hideChildrenInMenu: true
            },
             {
              path: '/insurance/tocsin',
              name: "insuranceTocsin",
              meta: { title: "事故报险" },
              component: () =>
                import(/* webpackChunkName: "business" */ "./views/Insurance/Tocsin")
            },
            // {
            //   path: "/insurance/insuranceKind",
            //   name: "insuranceKind",
            //   meta: { title: "保险种类" },
            //   component: () =>
            //     import(/* webpackChunkName: "business" */ "./views/Insurance/InsuranceKind")
            // },
            // {
            //   path: "/insurance/insuranceBuy",
            //   name: "insuranceBuy",
            //   meta: { title: "投保信息" },
            //   component: () =>
            //     import(/* webpackChunkName: "business" */ "./views/Insurance/InsuranceBuy")
            // },
          ]
        },
        // {
        //   path: "/customer",
        //   name: "customer",
        //   meta: { icon: "smile", title: "客户中心", authority: ["BOSS", "技术", "运营支持"] },
        //   component: { render: h => h("router-view") },
        //   isChildren: true,
        //   children: [
        //     {
        //       path: "/customer",
        //       redirect: "/customer/index",
        //       hideChildrenInMenu: true
        //     }
        //   ]
        // },
        {
          path: "/contract",
          name: "contract",
          meta: { icon: "file-protect", title: "合同管理", authority: ["BOSS", "技术", "运营支持"], type: ['玄鸟内部'] },
          component: { render: h => h("router-view") },
          isChildren: true,
          children: [
            {
              path: "/contracts",
              redirect: "/contracts/contractList",
              hideChildrenInMenu: true
            }, {
              path: "/contracts/contractList",
              name: "contractList",
              meta: { title: "员工合同" },
              component: () =>
                import(/* webpackChunkName: "contract" */ "./views/Contracts/Index")
            }]
        }, {
          path: "/account",
          name: "account",
          meta: { icon: "user", title: "账号", type: ['玄鸟内部'], authority: ["BOSS", "技术", "运营支持"] },
          component: { render: h => h("router-view") },
          isChildren: true,
          children: [
            {
              path: "/account",
              redirect: "/account/userInfo",
              hideChildrenInMenu: true
            }, {
              path: "/account/userInfo",
              name: "userInfo",
              meta: { title: "全部账号", authority: ["BOSS", "技术", "运营支持"] },
              component: () =>
                import(/* webpackChunkName: "account" */ "./views/Account/UserInfo")
            }, {
              path: "/setting/companyList",
              name: "companyList",
              meta: { title: "签约主体", authority: ["BOSS", "运营支持", "技术"] },
              component: () =>
                import(/* webpackChunkName: "setting" */ "./views/Setting/CompanyList")
            }, {
              path: "/employees/account",
              name: "employeesAccount",
              meta: { title: "内部账号", authority: ["BOSS", "技术", "运营支持"] },
              component: () =>
                import(/* webpackChunkName: "business" */ "./views/Employees/Account")
            },{
              path: "/resource/thirdParty",
              name: "thirdParty",
              meta: { title: "三方渠道", authority: ["BOSS", "技术", "运营支持"] },
              component: () =>
                import(/* webpackChunkName: "account" */ "./views/Resource/ThirdParty")
            },{
              path: "/resource/channelAccount",
              name: "resourceChannelAccount",
              meta: { title: "渠道账号", authority: ["BOSS", "技术", "运营支持",] },
              component: () =>
                import(/* webpackChunkName: "account" */ "./views/Resource/ChannelAccount")
            }, {
              path: "/setting/department",
              name: "department",
              meta: { title: "部门", authority: ["BOSS", "运营支持", "技术"] },
              component: () =>
                import(/* webpackChunkName: "setting" */ "./views/Setting/Department")
            }, 
            {
              path: "/account/role",
              name: "role",
              meta: { title: "岗位", authority: ["BOSS", "技术", "运营支持"] },
              component: () =>
                import(/* webpackChunkName: "account" */ "./views/Account/Role")
            },
          ]
        }, {
          path: "/setting",
          name: "setting",
          meta: { icon: "setting", title: "设置" },
          component: { render: h => h("router-view") },
          isChildren: true,
          children: [{
            path: "/setting/password",
            name: "password",
            meta: { title: "修改密码" },
            component: () =>
              import(/* webpackChunkName: "setting" */ "./views/Setting/Password")
          },
          {
            path: "/document",
            redirect: "/setting/document",
            hideChildrenInMenu: true
          }, {
            path: "/setting/message",
            name: "message",
            meta: { title: "消息列表" },
            component: () =>
              import(/* webpackChunkName: "user" */ "./views/Setting/Message"),

          }
          ]
        },

      ]
    },
    {
      path: "/403",
      name: "403",
      hideInMenu: true,
      component: ForBidden
    },
    {
      path: "*",
      name: "404",
      hideInMenu: true,
      component: NoFound
    }, {
      path: "/500",
      name: "500",
      hideInMenu: true,
      component: NoNotwork
    },
    {
      path: "logistics/index",
      name: "logisticsModel",
      // meta: { icon: "user", title: "城配物流" },
      component: { render: h => h("router-view") },
      hideInMenu: true,
      isChildren: true,
      children: [
        {
          path: "/logistics/index",
          name: "logisticsIndex",
          component: () =>
            import(/* webpackChunkName: "logistics" */ "./views/Logistics/Index"),
          children: [
            {
              path: "/logistics/JDOrder",
              name: "logisticsJDOrder",
              component: () =>
                import(/* webpackChunkName: "logistics" */ "./views/Logistics/JDOrder")
            },
            {
              path: "/logistics/HLOrder",
              name: "logisticsHLOrder",
              component: () =>
                import(/* webpackChunkName: "logistics" */ "./views/Logistics/HLOrder")
            },
            {
              path: "/logistics/driverStatus",
              name: "driverStatus",
              component: () =>
                import(/* webpackChunkName: "logistics" */ "./views/Logistics/DriverStatus")
            },
            {
              path: "/logistics/setOrder",
              name: "setOrder",
              component: () =>
                import(/* webpackChunkName: "logistics" */ "./views/Logistics/SetOrder")
            },
            {
              path: "/logistics/grand",
              name: "grand",
              component: () =>
                import(/* webpackChunkName: "logistics" */ "./views/Logistics/Grand")
            }, {
              path: "/logistics/driver",
              name: "driver",
              component: () =>
                import(/* webpackChunkName: "logistics" */ "./views/Logistics/Driver")
            }, {
              path: "/logistics/owner",
              name: "owner",
              component: () =>
                import(/* webpackChunkName: "logistics" */ "./views/Logistics/Owner")
            }, {
              path: "/logistics/administrator",
              name: "administrator",
              component: () =>
                import(/* webpackChunkName: "logistics" */ "./views/Logistics/Administrator")
            }, {
              path: '/logistics/logisticsDownload',
              name: "logisticsDownload",
              component: () =>
                import(/* webpackChunkName: "logistics" */ "./views/Logistics/Download")
            }, {
              path: "/logistics/logisticsArea",
              name: "logisticsArea",
              component: () =>
                import(/* webpackChunkName: "logistics" */ "./views/Logistics/Area")
            }
          ]
        },

      ]
    },
    {
      path: "clean",
      name: "cleanModel",
      component: () =>
        import(/* webpackChunkName: "clean" */ "./views/Clean/Index"),
      // meta: { icon: "user", title: "公寓服务" },
      hideInMenu: true,
      isChildren: true,
      children: [
        {
          path: "/clean/index",
          name: "cleanIndex",
          component: { render: h => h("router-view") },
          children: [
            {
              path: "/clean",
              redirect: "/clean/index",
              hideChildrenInMenu: true
            },
            {
              path:"/clean/set",
              name:"cleanSet",
              component: () =>
                import(/* webpackChunkName: "clean" */ "./views/Clean/Set")
            },
            {
              path: "/clean/order",
              name: "cleanOrder",
              component: () =>
                import(/* webpackChunkName: "clean" */ "./views/Clean/Order")
            },
            {
              path: "/clean/waitWork",
              name: "cleanWaitWork",
              component: () =>
                import(/* webpackChunkName: "clean" */ "./views/Clean/WaitWork")
            },
            {
              path: "/clean/settlement",
              name: "cleanSettlement",
              component: () =>
                import(/* webpackChunkName: "clean" */ "./views/Clean/Settlement")
            },
            {
              path: "/clean/ProSettle",
              name: "cleanProSettle",
              component: () =>
                import(/* webpackChunkName: "clean" */ "./views/Clean/ProSettle")
            },
            {
              path: "/clean/download",
              name: "cleanDownload",
              component: () =>
                import(/* webpackChunkName: "clean" */ "./views/Clean/Download")
            },
            {
              path: "/clean/cleanHouse",
              name: "cleanHouse",
              component: () =>
                import(/* webpackChunkName: "clean" */ "./views/Clean/House")
            },
            {
              path: "/clean/houseDetails",
              name: "cleanHouseDetails",
              component: () =>
                import(/* webpackChunkName: "clean" */ "@/components/clean/houseDetails")
            },
            {
              path: "/clean/batchSendOrders",
              name: "cleanBatchSendOrders",
              component: () =>
                import(/* webpackChunkName: "clean" */ "@/components/clean/batchSendOrders")
            },
            {
              path: "/clean/Administrator",
              name: "cleanAdmin",
              component: () =>
                import(/* webpackChunkName: "clean" */ "./views/Clean/Administrator")
            },
            {
              path: "/clean/Owner",
              name: "cleanOwner",
              component: () =>
                import(/* webpackChunkName: "clean" */ "./views/Clean/Owner")
            },
            {
              path: "/clean/cleaner",
              name: "cleanCleaner",
              component: () =>
                import(/* webpackChunkName: "clean" */ "./views/Clean/Cleaner")
            }, {
              path: "/clean/materialCompany",
              name: "cleanMaterialCompany",
              component: () =>
                import(/* webpackChunkName: "clean" */ "./views/Clean/MaterialCompany")
            }, {
              path: "/clean/materialWorker",
              name: "cleanMaterialWorker",
              component: () =>
                import(/* webpackChunkName: "clean" */ "./views/Clean/MaterialWorker")
            }, {
              path: "/clean/warehouseLog",
              name: "cleanWarehouseLog",
              component: () =>
                import(/* webpackChunkName: "clean" */ "./views/Clean/WarehouseLog")
            }, {
              path: "/clean/applyLog",
              name: "cleanApplyLog",
              component: () =>
                import(/* webpackChunkName: "clean" */ "./views/Clean/ApplyLog")
            }, {
              path: "/clean/waitSchedule",
              name: "cleanWaitSchedule",
              component: () =>
                import(/* webpackChunkName: "clean" */ "./views/Clean/WaitSchedule")
            }
          ]
        },

      ]
    },
    {
      path: "retail",
      name: "retailModel",
      component: { render: h => h("router-view") },
      hideInMenu: true,
      isChildren: true,
      children: [{
        path: "/retail/index",
        name: "retailIndex",
        component: () =>
          import(/* webpackChunkName: "retail" */ "./views/Retail/Index"),
        children: [{
          path: "/retail",
          redirect: "/retail/index",
          hideChildrenInMenu: true
        }, {
          path: "/retail/Worker",
          name: "RetailWorker",
          component: () =>
            import(/* webpackChunkName: "retail" */ "./views/Retail/Worker")
        }, {
          path: "/retail/Shops",
          name: "RetailShops",
          component: () =>
            import(/* webpackChunkName: "retail" */ "./views/Retail/Shops")
        }, {
          path: "/retail/Administrator",
          name: "RetailAdministrator",
          component: () =>
            import(/* webpackChunkName: "retail" */ "./views/Retail/Administrator")
        }, {
          path: "/retail/workOrder",
          name: "retailWorkOrder",
          component: () =>
            import(/* webpackChunkName: "retail" */ "./views/Retail/WorkOrder")
        }, {
          path: "/retail/proOrder",
          name: "retailProOrder",
          component: () =>
            import(/* webpackChunkName: "retail" */ "./views/Retail/ProOrder")
        }, {
          path: "/retail/setOrder",
          name: "retailSetOrder",
          component: () =>
            import(/* webpackChunkName: "retail" */ "./views/Retail/SetOrder")
        }, {
          path: "/retail/workOrderMonth",
          name: "retailWorkOrderMonth",
          component: () =>
            import(/* webpackChunkName: "retail" */ "./views/Retail/WorkOrderMonth")
        }, {
          path: "/retail/settlement",
          name: "retailSettlement",
          component: () =>
            import(/* webpackChunkName: "retail" */ "./views/Retail/Settlement")
        }, {
          path: "/retail/proSettle",
          name: "retailProSettle",
          component: () =>
            import(/* webpackChunkName: "retail" */ "./views/Retail/ProSettle")
        }]
      }]
    }, {
      path: "manpower",
      name: "manpowerMondel",
      component: { render: h => h("router-view") },
      hideInMenu: true,
      isChildren: true,
      children: [{
        path: "/manpower/index",
        name: "manpowerIndex",
        component: () =>
          import(/* webpackChunkName: "manpower" */ "./views/Manpower/Index"),
        children: [{
          path: "/manpower",
          redirect: "/manpower/index",
          hideChildrenInMenu: true
        },
        {
          path: "/manpower/QSSettle",
          name: "ManpowerQSSettle",
          component: () =>
            import(/* webpackChunkName: "manpower" */ "./views/Manpower/QSSettle")
        }, {
          path:"/manpower/setAccount",
          name: "manpowerSetAccount",
          component: () =>
            import(/* webpackChunkName: "manpower" */ "./views/Manpower/SetAccount")
        },{
          path:"/manpower/recruitCostSet",
          name: "manpowerRecruitCostSet",
          component: () =>
            import(/* webpackChunkName: "manpower" */ "./views/Manpower/RecruitCostSet")
        },{
          path:"/manpower/recruitCostList",
          name: "manpowerRecruitCostList",
          component: () =>
            import(/* webpackChunkName: "manpower" */ "./views/Manpower/RecruitCostList")
        },{
          path:"/manpower/humanCostList",
          name: "manpowerHumanCostList",
          component: () =>
            import(/* webpackChunkName: "manpower" */ "./views/Manpower/HumanCostList")
        },{
          path: "/manpower/BDSettle",
          name: "ManpowerBDSettle",
          component: () =>
            import(/* webpackChunkName: "manpower" */ "./views/Manpower/BDSettle")
        }, {
          path: "/manpower/shops",
          name: "manpowerShops",
          component: () =>
            import(/* webpackChunkName: "manpower" */ "./views/Manpower/Shops")
        }, {
          path: "/manpower/Worker",
          name: "manpowerWorker",
          component: () =>
            import(/* webpackChunkName: "manpower" */ "./views/Manpower/Worker")
        }, {
          path: "/manpower/Administrator",
          name: "manpowerAdministrator",
          component: () =>
            import(/* webpackChunkName: "manpower" */ "./views/Manpower/Administrator")
        }, {
          path: "/manpower/workOrder",
          name: "manpowerWorkOrder",
          component: () =>
            import(/* webpackChunkName: "manpower" */ "./views/Manpower/WorkOrder")
        },{
          path: "/manpower/setOrder",
          name: "manpowerSetOrder",
          component: () =>
            import(/* webpackChunkName: "manpower" */ "./views/Manpower/SetOrder")
        }, {
          path: "/manpower/DYSettle",
          name: "manpowerDYSettle",
          component: () =>
            import(/* webpackChunkName: "manpower" */ "./views/Manpower/DYSettle")
        }, {
          path: "/manpower/JZSettle",
          name: "manpowerJZSettle",
          component: () =>
            import(/* webpackChunkName: "manpower" */ "./views/Manpower/JZSettle")
        }, {
          path: "/manpower/DCSettle",
          name: "manpowerDCSettle",
          component: () =>
            import(/* webpackChunkName: "manpower" */ "./views/Manpower/DCSettle")
        }, {
          path: "/manpower/MonthSettlement",
          name: "manpowerMonthSettlement",
          component: () =>
            import(/* webpackChunkName: "manpower" */ "./views/Manpower/MonthSettlement")
        }, {
          path: "/manpower/ProSettlement",
          name: "manpowerProSettlement",
          component: () =>
            import(/* webpackChunkName: "manpower" */ "./views/Manpower/ProSettlement")
        }]
      }]
    },
    {
      path: "/equipment",
      name: "equipmentModel",
      component: { render: h => h("router-view") },
      hideInMenu: true,
      isChildren: true,
      children: [{
        path: "/equipment/index",
        name: "equipmentIndex",
        component: () =>
          import(/* webpackChunkName: "equipment" */ "./views/Equipment/Index"),

        children: [{
          path: "/equipment",
          redirect: "/equipment/index",
          hideChildrenInMenu: true
        },
        {
          path:"/equipment/machine",
          name: "equipmentMachine",
          component: () =>
            import(/* webpackChunkName: "equipment" */ "./views/Equipment/Machine")
        },{
          path:"/equipment/Goods",
          name: "equipmentGoods",
          component: () =>
            import(/* webpackChunkName: "equipment" */ "./views/Equipment/Goods")
        },{
          path:"/equipment/MachineIn",
          name: "equipmentMachineIn",
          component: () =>
            import(/* webpackChunkName: "equipment" */ "./views/Equipment/MachineIn")
        },{
          path:"/equipment/warehouseMaterial",
          name: "equipmentWarehouseMaterial",
          component: () =>
            import(/* webpackChunkName: "equipment" */ "./views/Equipment/WarehouseMaterial")
        },{
          path:"/equipment/warehouseStorageOrder",
          name: "equipmentWarehouseStorageOrder",
          component: () =>
            import(/* webpackChunkName: "equipment" */ "./views/Equipment/WarehouseStorageOrder")
        },{
          path:"/equipment/warehouseCheckOrder",
          name: "equipmentWarehouseCheckOrder",
          component: () =>
            import(/* webpackChunkName: "equipment" */ "./views/Equipment/WarehouseCheckOrder")
        },{
          path:"/equipment/HySalesLog",
          name: "equipmentHySalesLog",
          component: () =>
            import(/* webpackChunkName: "equipment" */ "./views/Equipment/HySalesLog")
        },{
          path:"/equipment/HySlotLog",
          name: "equipmentHySlotLog",
          component: () =>
            import(/* webpackChunkName: "equipment" */ "./views/Equipment/HySlotLog")
        },{
          path:"/equipment/mistiming",
          name: "equipmentMistiming",
          component: () =>
            import(/* webpackChunkName: "equipment" */ "./views/Equipment/Mistiming")
        },
        {
          path: "/equipment/equipmentGYOrder",
          name: "equipmentGYOrder",
          component: () =>
            import(/* webpackChunkName: "equipment" */ "./views/Equipment/GYOrder")
        },{
          path:"/equipment/goodsAllocation",
          name: "equipmentGoodsAllocation",
          component: () =>
            import(/* webpackChunkName: "equipment" */ "./views/Equipment/GoodsAllocation")
        },{
          path:"/equipment/goodsSendBack",
          name: "equipmentGoodsSendBack",
          component: () =>
            import(/* webpackChunkName: "equipment" */ "./views/Equipment/GoodsSendBack")
        },{
          path:"/equipment/deviceMaterial",
          name: "equipmentDeviceMaterial",
          component: () =>
            import(/* webpackChunkName: "equipment" */ "./views/Equipment/DeviceMaterial")
        },{
          path:"/equipment/DeviceGuard",
          name: "equipmentDeviceGuard",
          component: () =>
            import(/* webpackChunkName: "equipment" */ "./views/Equipment/DeviceGuard")
        },{
          path:"/equipment/monthSettlement",
          name: "equipmentMonthSettlement",
          component: () =>
            import(/* webpackChunkName: "equipment" */ "./views/Equipment/MonthSettlement")
        },{
          path:"/equipment/proSettlement",
          name: "equipmentProSettlement",
          component: () =>
            import(/* webpackChunkName: "equipment" */ "./views/Equipment/ProSettlement")
        },{
          path:"/equipment/warehouseOutOrder",
          name: "equipmentWarehouseOutOrder",
          component: () =>
            import(/* webpackChunkName: "equipment" */ "./views/Equipment/WarehouseOutOrder")
        },{
          path:"/equipment/displayExample",
          name: "equipmentDisplayExample",
          component: () =>
            import(/* webpackChunkName: "equipment" */ "./views/Equipment/DisplayExample")
        },{
          path:"/equipment/machineCheck",
          name: "equipmentMachineCheck",
          component: () =>
            import(/* webpackChunkName: "equipment" */ "./views/Equipment/MachineCheck")
        },{
          path:"/equipment/machineOrder",
          name: "equipmentMachineOrder",
          component: () =>
            import(/* webpackChunkName: "equipment" */ "./views/Equipment/MachineOrder")
        },
        {
          path: "/equipment/administrator",
          name: "equipmentAdministrator",
          component: () =>
            import(/* webpackChunkName: "equipment" */ "./views/Equipment/Administrator")
        }, {
          path: "/equipment/worker",
          name: "equipmentWorker",
          component: () =>
            import(/* webpackChunkName: "equipment" */ "./views/Equipment/Worker")
        }]
      }]
    }
  ]
});
export default router;
router.beforeEach((to, from, next) => {
  if (to.path !== from.path) {
    NProgress.start();
  }
  const record = findLast(to.matched, record => record.meta.authority);
  // const recordType = findLast(to.matched, recordType => recordType.meta.type);
  if (record && !check(record.meta.authority)) {
    if(localStorage.getItem("xnserve-authority")!=null){
      if (to.path !== "/user/login") {
        next({
          path: "/user/login"
        });
      } else if (to.path !== "/403") {
        notification.error({
          message: "403",
          description: "你没有权限访问，请联系管理员咨询。"
        });
        next({
          path: "/403"
        });
      }
    }else{
      router.push("/404")
    }
    NProgress.done();
  }
  next();
});
router.afterEach(() => {
  NProgress.done()
})

